import { useDAL } from '@/contexts/useDAL';

import { AccountIndicator } from '../accountIndicator';

export const RestoreAccountIndicator = ({
  providerAccountId,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
}: {
  providerAccountId: string;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
}) => {
  const dal = useDAL();
  const { data: body } = dal.cloudAccounts.restore.list();
  const account = body?.accounts.find(
    (a) => a.providerAccountId === providerAccountId
  );

  return account ? (
    <AccountIndicator
      account={account}
      showCloudIndicator={showCloudIndicator}
      showAccountName={showAccountName}
      showAccountId={showAccountId}
    />
  ) : null;
};
